import { render, staticRenderFns } from "./RetainedEarningView.vue?vue&type=template&id=367e28c0"
import script from "./RetainedEarningView.vue?vue&type=script&lang=js"
export * from "./RetainedEarningView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports